import { CapoPlugin } from "/builds/webcontact/marxzell/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];